import format from 'root-core/utils/text/stringFormatFilter.js'
import * as validations from './validations.js'
import spacecase from 'root-core/utils/text/spacecase.js'
import emailRegex from 'regex-email'

export default function (sellingCompany) {
  function present (field) {
    return validations.required((value, object, property) =>
      format(
        sellingCompany.errorMessages.required,
        field || spacecase(property)
      )
    )
  }

  function minLength (length, field) {
    return function (value, is, object, property) {
      if (value.length < length) {
        return format(
          sellingCompany.errorMessages.minLength,
          length,
          field || spacecase(property)
        )
      }
    }
  }

  function maxLength (length, field) {
    return function (value, is, object, property) {
      if (value.length > length) {
        return format(
          sellingCompany.errorMessages.maxLength,
          length,
          field || spacecase(property)
        )
      }
    }
  }

  function pattern (regex, field) {
    return function (value) {
      if (!regex.test(value)) {
        return `Please enter a valid value for your ${field}.`
      }
    }
  }

  function name (field) {
    return function (value, is) {
      is(present(field)) &&
        is(minLength(2, field)) &&
        is(maxLength(30, field)) &&
        is(pattern(/^[A-Za-z-' ]+$/, field))
    }
  }

  function email () {
    return function (value, is) {
      if (is(present()) && !emailRegex.test(value.trim())) {
        return sellingCompany.errorMessages.email
      }
    }
  }

  return {
    contact: {
      email: email(),
      firstName: name('first name'),
      lastName: name('last name'),
    },
    friend: {
      email: (value, is, object) => {
        if (object.sendToFriend) {
          return email()(value, is)
        }
      },
      lastName: (value, is, object) => {
        if (object.sendToFriend) {
          return name('last name')(value, is)
        }
      },
      firstName: (value, is, object) => {
        if (object.sendToFriend) {
          return name('first name')(value, is)
        }
      },
    },
  }
}
